import { Text } from "@repo/components/src/ui/text";
import { ExternalPathString, Link } from "expo-router";
import { StyleSheet } from "react-native";
import Markdown from "react-native-markdown-display";
import { Box } from "../../ui/box";
import { MarkdownProps } from "./types";
import { markdownItInstance } from "./utils";

export default function MontuMarkdown(props: MarkdownProps) {
  const {
    children: realCh,
    baseSize = 12,
    numberOfLines,
    color,
    linkColor,
  } = props;
  return (
    <Markdown
      markdownit={markdownItInstance}
      style={{
        body: {
          fontSize: baseSize,
          ...(color ? { color } : {}),
        },
        heading1: {
          fontWeight: "500",
          fontSize: baseSize + 10,
        },
        heading2: {
          fontWeight: "500",
          fontSize: baseSize + 8,
        },
        heading3: {
          fontWeight: "500",
          fontSize: baseSize + 6,
        },
        heading4: {
          fontWeight: "500",
          fontSize: baseSize + 4,
        },
        heading5: {
          fontWeight: "500",
          fontSize: baseSize + 2,
        },
        heading6: {
          fontWeight: "500",
          fontSize: baseSize,
        },
        paragraph: {
          marginTop: 0,
          marginBottom: 0,
        },
        underline: {
          textDecorationLine: "underline",
        },
        link: {
          color: linkColor ?? "blue",
          textDecorationLine: "underline",
        },
      }}
      rules={{
        underline: (node, children, _, styles, a = {}) => {
          return (
            <Text
              key={node.key}
              style={StyleSheet.flatten([a, styles.underline])}
            >
              {children}
            </Text>
          );
        },
        link: (node, children) => {
          const href = node.attributes.href as ExternalPathString;
          return (
            <Link href={href} target="_blank" key={node.key}>
              {children}
            </Link>
          );
        },
        text: (node, _, __, styles, inheritedStyles = {}) => {
          return (
            <Text
              key={node.key}
              style={StyleSheet.flatten([inheritedStyles, styles.text])}
            >
              {node.content}
            </Text>
          );
        },
        textgroup: (node, children, _, styles, inheritedStyles = {}) => (
          <Text
            key={node.key}
            style={StyleSheet.flatten([inheritedStyles, styles.textgroup])}
            numberOfLines={numberOfLines}
          >
            {children}
          </Text>
        ),
        paragraph: (node, children, _, __) => {
          return (
            <Box key={node.key} className={node.index > 0 ? "mt-2" : ""}>
              {children}
            </Box>
          );
        },
      }}
    >
      {realCh}
    </Markdown>
  );
}
